import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { UiService } from '@services/category-lists/ui.service';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class ChangePwdGuard implements CanActivate {
    constructor(
        private uiSrv: UiService,
        private authSrv: AuthService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if ((next.queryParams.token && next.queryParams.id
            && next.queryParams.exp && next.queryParams.user)) {
            return true;
        }

        if (this.authSrv.getDecodedToken()) {
            return true;
        }

        this.uiSrv.showSnackbar('auth.changePassword.passwordResetError', true, 5000);
        this.authSrv.logout();
        return false;
    }
}
